/** Main page tab + export accents per expense group (no green). */
export const GROUP_TAB_ACCENT = {
  fixed: {
    active: 'bg-gradient-to-r from-indigo-600 to-indigo-700 text-white shadow-md',
    focusRing: 'focus-visible:ring-indigo-500',
    exportHover: 'hover:bg-indigo-50 hover:border-indigo-200 hover:text-indigo-800',
    stat: 'text-indigo-700',
  },
  variable: {
    active: 'bg-gradient-to-r from-violet-600 to-violet-700 text-white shadow-md',
    focusRing: 'focus-visible:ring-violet-500',
    exportHover: 'hover:bg-violet-50 hover:border-violet-200 hover:text-violet-800',
    stat: 'text-violet-700',
  },
  advances: {
    active: 'bg-gradient-to-r from-teal-600 to-teal-700 text-white shadow-md',
    focusRing: 'focus-visible:ring-teal-500',
    exportHover: 'hover:bg-teal-50 hover:border-teal-200 hover:text-teal-800',
    stat: 'text-teal-700',
  },
  salaries: {
    active: 'bg-gradient-to-r from-blue-600 to-sky-500 text-white shadow-md',
    focusRing: 'focus-visible:ring-blue-500',
    exportHover: 'hover:bg-blue-50 hover:border-blue-200 hover:text-blue-800',
    stat: 'text-blue-700',
  },
};

/** Theme tokens for fixed / variable expense UI (no green). */
export const EXPENSE_THEMES = {
  fixed: {
    key: 'fixed',
    label: 'Fixed',
    title: 'Fixed expenses',
    subtitle: 'Recurring costs like rent, utilities, and subscriptions',
    icon: 'fixed',
    header: 'from-slate-700 via-slate-700 to-indigo-800',
    tabActive: 'text-indigo-800',
    subNavWrap:
      'inline-flex w-full sm:w-auto p-1.5 bg-gradient-to-r from-indigo-50 via-slate-50 to-indigo-50/80 border border-indigo-100 rounded-xl shadow-sm',
    subNavActive: 'bg-gradient-to-r from-indigo-600 to-indigo-700 text-white shadow-md',
    subNavIdle: 'text-gray-600 hover:text-indigo-800 hover:bg-white/90',
    subNavBadgeActive: 'bg-white/25 text-white',
    subNavBadgeIdle: 'bg-indigo-100 text-indigo-800',
    iconTile: 'bg-indigo-500/25 ring-1 ring-white/20',
    accent: 'indigo',
    focus: 'focus:border-indigo-600 focus:ring-indigo-600/25',
    fieldFocus: 'focus:border-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600/25',
    stripe: 'bg-indigo-500',
    stripeAlt: 'bg-slate-500',
    pillActive: 'bg-indigo-700 text-white shadow-md',
    pillIdle: 'bg-gray-100 text-gray-700 hover:bg-indigo-50 hover:text-indigo-900',
    btn: 'from-indigo-700 to-indigo-800 hover:from-indigo-800 hover:to-slate-800',
    btnRing: 'focus:ring-indigo-600',
    amount: 'text-indigo-700',
    amountBg: 'bg-indigo-100 text-indigo-900',
    hoverRow: 'hover:bg-indigo-50/30',
    groupRow: 'bg-indigo-50/90 text-indigo-900',
    groupSub: 'text-indigo-700',
    filterIcon: 'text-indigo-600',
    filterFocus: 'focus:border-indigo-600 focus:ring-indigo-600',
    dropdownHover: 'hover:bg-indigo-50',
    file: 'file:bg-indigo-50 file:text-indigo-800 hover:file:bg-indigo-100',
    mobileFilterActive: 'bg-indigo-50 border-indigo-200 text-indigo-800 hover:bg-indigo-100',
    mobileFilterBadge: 'bg-indigo-600',
    emptyIcon: 'text-indigo-400',
    emptyBg: 'bg-indigo-100',
    fileZone: 'border-indigo-200 bg-gradient-to-br from-slate-50 to-indigo-50/40 hover:border-indigo-300 hover:bg-indigo-50/60',
    fileZoneActive: 'border-indigo-400 bg-indigo-50/80 ring-2 ring-indigo-200/60',
    fileBtn: 'bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 text-white shadow-sm',
    fileIcon: 'text-indigo-500',
    fileChip: 'bg-indigo-50 text-indigo-900 ring-indigo-200',
    addLabel: 'Add fixed expense',
    historyTitle: 'Expense history',
    searchPlaceholder: 'Search category, entry, or description…',
  },
  variable: {
    key: 'variable',
    label: 'Variable',
    title: 'Variable expenses',
    subtitle: 'One-off costs like supplies, travel, and miscellaneous spend',
    icon: 'variable',
    header: 'from-slate-700 via-slate-700 to-violet-800',
    tabActive: 'text-violet-800',
    subNavWrap:
      'inline-flex w-full sm:w-auto p-1.5 bg-gradient-to-r from-violet-50 via-slate-50 to-violet-50/80 border border-violet-100 rounded-xl shadow-sm',
    subNavActive: 'bg-gradient-to-r from-violet-600 to-violet-700 text-white shadow-md',
    subNavIdle: 'text-gray-600 hover:text-violet-800 hover:bg-white/90',
    subNavBadgeActive: 'bg-white/25 text-white',
    subNavBadgeIdle: 'bg-violet-100 text-violet-800',
    iconTile: 'bg-violet-500/25 ring-1 ring-white/20',
    accent: 'violet',
    focus: 'focus:border-violet-600 focus:ring-violet-600/25',
    fieldFocus: 'focus:border-violet-600 focus:outline-none focus:ring-2 focus:ring-violet-600/25',
    stripe: 'bg-violet-500',
    stripeAlt: 'bg-slate-500',
    pillActive: 'bg-violet-700 text-white shadow-md',
    pillIdle: 'bg-gray-100 text-gray-700 hover:bg-violet-50 hover:text-violet-900',
    btn: 'from-violet-700 to-violet-800 hover:from-violet-800 hover:to-slate-800',
    btnRing: 'focus:ring-violet-600',
    amount: 'text-violet-700',
    amountBg: 'bg-violet-100 text-violet-900',
    hoverRow: 'hover:bg-violet-50/30',
    groupRow: 'bg-violet-50/90 text-violet-900',
    groupSub: 'text-violet-700',
    filterIcon: 'text-violet-600',
    filterFocus: 'focus:border-violet-600 focus:ring-violet-600',
    dropdownHover: 'hover:bg-violet-50',
    file: 'file:bg-violet-50 file:text-violet-800 hover:file:bg-violet-100',
    mobileFilterActive: 'bg-violet-50 border-violet-200 text-violet-800 hover:bg-violet-100',
    mobileFilterBadge: 'bg-violet-600',
    emptyIcon: 'text-violet-400',
    emptyBg: 'bg-violet-100',
    fileZone: 'border-violet-200 bg-gradient-to-br from-slate-50 to-violet-50/40 hover:border-violet-300 hover:bg-violet-50/60',
    fileZoneActive: 'border-violet-400 bg-violet-50/80 ring-2 ring-violet-200/60',
    fileBtn: 'bg-gradient-to-r from-violet-600 to-violet-700 hover:from-violet-700 hover:to-violet-800 text-white shadow-sm',
    fileIcon: 'text-violet-500',
    fileChip: 'bg-violet-50 text-violet-900 ring-violet-200',
    addLabel: 'Add variable expense',
    historyTitle: 'Expense history',
    searchPlaceholder: 'Search category, entry, description, or person…',
  },
};

export function getExpenseTheme(variant) {
  return EXPENSE_THEMES[variant] || EXPENSE_THEMES.fixed;
}

export function getGroupTabAccent(groupKey) {
  return GROUP_TAB_ACCENT[groupKey] || GROUP_TAB_ACCENT.fixed;
}

/** Labour / advances section (matches salary sub-nav pattern). */
export const LABOUR_SUB_NAV = {
  header: 'from-slate-700 via-slate-700 to-teal-800',
  iconTile: 'bg-teal-500/25 ring-1 ring-white/20',
  wrap:
    'inline-flex w-full sm:w-auto p-1.5 bg-gradient-to-r from-teal-50 via-slate-50 to-teal-50/80 border border-teal-100 rounded-xl shadow-sm',
  active: 'bg-gradient-to-r from-teal-600 to-teal-700 text-white shadow-md',
  idle: 'text-gray-600 hover:text-teal-800 hover:bg-white/90',
  badgeActive: 'bg-white/25 text-white',
  badgeIdle: 'bg-teal-100 text-teal-800',
  topStripe: 'from-teal-600 via-teal-500 to-teal-400',
};
